import React from 'react'
import {
  Box,
  Typography,
  Chip,
  useMediaQuery,
  useTheme
} from '@mui/material'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import { RelocateState } from '../types'

interface RelocateHeaderProps {
  sharedState: RelocateState
}

export const RelocateHeader: React.FC<RelocateHeaderProps> = ({
  sharedState
}) => {
  const { sku, productOriginName, isGreenSale } = sharedState
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (!sku || !productOriginName) {
    return null
  }

  if (isMobile) {
    // Layout compacto para mobile con labels
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        mb={1}
        p={1}
        bgcolor='#f5f5f5'
        borderRadius='4px'
      >
        <Typography
          variant='caption'
          style={{
            color: theme.palette.text.secondary,
            marginBottom: 4
          }}
        >
          Reubicando
        </Typography>
        
        {isGreenSale && (
          <Chip
            icon={<EventAvailableIcon style={{ color: 'white', fontSize: 18 }} />}
            label='Venta en Verde'
            size='small'
            style={{
              backgroundColor: '#2e7d32',
              color: '#ffffff',
              fontWeight: 600,
              marginBottom: 8,
              height: 20,
              fontSize: '0.70rem'
            }}
          />
        )}        
        <Box display='flex' justifyContent='space-between' width='100%'>
          <Typography
            variant='body2'
            style={{
              color: theme.palette.primary.main,
              fontWeight: 500
            }}
          >
            SKU: {sku}
          </Typography>

          <Typography
            variant='body2'
            style={{
              color: theme.palette.secondary.main,
              fontWeight: 500
            }}
          >
            Marca: {productOriginName}
          </Typography>
        </Box>
      </Box>
    )
  }

  // Layout completo para desktop
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='center'
      mb={1}
      p={1}
      bgcolor='#f5f5f5'
      borderRadius='8px'
    >
      <Typography
        variant='body1'
        style={{
          marginRight: '12px',
          textAlign: 'center'
        }}
      >
        Reubicando
      </Typography>
      <Box
      display='flex'
      flexDirection='row'
      alignItems='center'>
        {isGreenSale && (
          <Chip
            icon={<EventAvailableIcon style={{ color: 'white', fontSize: 18 }} />}
            label='Venta en verde'
            style={{
              backgroundColor: '#2e7d32', 
              color: '#fff', 
              marginRight: '8px',
              fontSize: '0.8125rem',
              fontWeight: 600,
              border: 'none'
            }}
          />
        )}        
        <Chip
          label={`SKU: ${sku}`}
          color='primary'
          variant='outlined'
          style={{
            marginRight: '8px',
            fontSize: '0.8125rem'
          }}
        />
        <Chip
          label={`Marca: ${productOriginName}`}
          color='secondary'
          variant='outlined'
          style={{
            fontSize: '0.8125rem'
          }}
        />
      </Box>
    </Box>
  )
}
